import { Label } from '../ui/label'
import { Input } from '../ui/input'
import { Button } from '../ui/button'
import { useTranslation } from 'next-i18next'
import { PasswordInput } from './password-field'
import { Formik } from 'formik'

import useAuth from '@/contexts/useAuth'
import Link from 'next/link'
import ErrorMessage from '../ui/error-message'
import { useErrors } from '@/hooks/use-errors'

export function LoginForm() {
  const { t } = useTranslation('auth')
  const { login } = useAuth()
  const { handleError } = useErrors()

  return (
    <Formik
      validateOnChange={false}
      validateOnBlur={false}
      initialValues={{ email: '', password: '' }}
      onSubmit={async (values, { setSubmitting, setErrors }) => {
        setSubmitting(true)
        try {
          await login(values)
        } catch (error: any) {
          handleError(error, setErrors)
        } finally {
          setSubmitting(false)
        }
      }}
    >
      {({
        values,
        errors,
        touched,
        handleChange,
        handleSubmit,
        isSubmitting,
      }) => (
        <form onSubmit={handleSubmit}>
          <div className="grid gap-4">
            <fieldset>
              <Label htmlFor="email">{t('email')}</Label>
              <div>
                <Input
                  id="email"
                  type="email"
                  placeholder="m@example.com"
                  required
                  name="email"
                  onChange={handleChange}
                  value={values.email}
                />
                <ErrorMessage message={touched.email && errors.email} />
              </div>
            </fieldset>
            <fieldset>
              <Label htmlFor="password">{t('password')}</Label>

              <PasswordInput
                id="password"
                required
                name="password"
                onChange={handleChange}
                value={values.password}
              />
              <ErrorMessage message={touched.password && errors.password} />
            </fieldset>
            <Link
              href="/auth/forgot-password"
              className="flex text-xs font-light uppercase text-gray-500"
            >
              {t('forgot_password?')}
            </Link>

            <Button
              type="submit"
              className="mt-4 w-full"
              disabled={isSubmitting}
            >
              {t('login')}
            </Button>
          </div>
          {/* <div className="mt-4 text-center text-sm">
            {t('no_account?')}
            <Link href="/auth/signup" className="ml-1 underline">
              {t('signup')}
            </Link>
          </div> */}
        </form>
      )}
    </Formik>
  )
}
